export default __webpack_public_path__ + "static/media/i199hk.1fd66218.webp";